/**
 * @module events/types/progress
 */

/**
 * @type {string}
 */
export default 'progress'
